module.exports = __webpack_public_path__ + "img/cropped-pak.baa23966.png";